<template>
  <TemplateModal
    ref="modal"
    center
    width="550"
    empty
    :sendFunction="onSendFunction"
    padding="50px 40px 20px"
    persistent
  >
    <template v-slot:activator>
      <BaseButton
        v-if="isSeveralRecipients"
        :text="
          localStorage.translations.pages.common.buttons.select +
          ' (' +
          severalRecipients.length +
          ')'
        "
        :default_icon="'button-confirm'"
        :disabled="severalRecipients.length <= 0"
        @click="onOpen"
      />
      <ChatFilesUploadButton v-else />
    </template>
    <div class="main d-grid gap-5 w-100">
      <h4 class="main-title f18 fw500 mt-n5" v-if="chatFileSelect.length > 1 || chatMessageEdit">
        {{
          (chatMessageEdit
            ? localStorage.translations.pages.common.breadcrumbs['redaktirovanie'] + '. '
            : '') +
          `${localStorage.translations.pages.common.text.selected_files}: ${chatFileSelect.length}`
        }}
      </h4>
      <div
        class="main-files d-flex flex-column gap-2 overflow-y-auto overflow-x-visible"
        v-if="chatFileSelect.length"
      >
        <BaseFileView
          v-for="(file, key) in chatFileSelect"
          :key="key"
          :itemKey="key"
          :items="chatFileSelect"
          :isSelect="{ change: true, delete: chatMessageEdit ? chatFileSelect.length > 1 : true }"
          :isUpload="sendingInProgress"
          :uploadInfo="
            chatFileUploads && chatFileUploads[identity] && chatFileUploads[identity][key]
          "
          @changeFile="onChangeFile"
          @deleteFile="onDeleteFile"
          :needApiDomain="chatApiDomain + '/static'"
        />
      </div>
      <BaseInput
        :label="chatTranslations.message"
        :placeholder="chatTranslations.write_message + '...'"
        v-model="text"
        type="textarea"
        no-resize
        :rows="text !== null && (textSend !== null) & (textSend.indexOf('\n') > -1) ? 2 : 1"
        @keydown.enter.exact.prevent="onSendFunction"
        @keydown.enter.shift.exact.prevent="text += '\n'"
      />
      <div class="main-buttons d-flex justify-space-between">
        <BaseButton
          v-if="chatMessageEdit"
          default_icon="button-back"
          :text="localStorage.translations.pages.common.buttons.otmenit"
          @click="onCloseModal"
          :disabled="sendingInProgress"
        />
        <ChatFilesUploadButton
          v-show="!chatMessageEdit"
          :default-button="false"
          ref="ChatFilesUploadButton"
          :disabled="sendingInProgress"
        />
        <BaseButton
          @click="onSendFunction"
          :text="
            localStorage.translations.pages.common.buttons[!chatMessageEdit ? 'send' : 'sohranit']
          "
          :default_icon="!chatMessageEdit ? 'chat-send' : 'button-save'"
          :disabled="sendingInProgress"
        />
      </div>
    </div>
  </TemplateModal>
</template>
<script>
import { mapGetters, mapActions, mapState, mapMutations } from 'vuex'
import ChatFilesUploadButton from 'components/chat/files/ChatFilesUploadButton'
export default {
  components: {
    ChatFilesUploadButton,
  },
  name: 'ChatFilesUploadModal',
  props: {
    onCreateMessage: Function,
    textSend: { type: String, default: '' },
    chatTranslations: Object,
    severalRecipients: { type: Array },
    chats: Array,
  },
  data() {
    return {
      text: '',
      sendingInProgress: false,
    }
  },
  computed: {
    ...mapState('chat/file', ['chatFileUploads', 'chatFileSelect']),
    ...mapState('chat/messages', ['chatMessageEdit']),
    ...mapGetters('user', ['userData']),
    ...mapState(['chatApiDomain']),
    modal() {
      return this.$refs && this.$refs.modal
    },
    dialog() {
      return this.$refs.modal && this.$refs.modal.dialog
    },
    isSeveralRecipients() {
      const itemIsArray = Array.isArray(this.severalRecipients)
      return itemIsArray
    },
    identity() {
      return this.chatMessageEdit
        ? 'chat_' + this.$route.params.id + '__id_' + this.chatMessageEdit.id
        : 'severalRecipients'
    },
  },
  watch: {
    dialog() {
      if (!this.dialog) {
        if (!this.isSeveralRecipients) {
          this.$emit('filesUploadModalClose', this.chatMessageEdit ? '' : this.text)
        }
        if (this.chatMessageEdit) {
          this.CANCEL_chatMessageEdit()
        }
        this.onDefalutData()
      } else {
        if (!this.isSeveralRecipients) {
          this.text = this.textSend
          this.$emit('filesUploadModalOpen')
        }
        if (this.chatMessageEdit) {
          this.text = this.chatMessageEdit.content
        }
      }
    },
    chatFileSelect() {
      if (!this.dialog && this.chatFileSelect.length && !this.isSeveralRecipients) {
        this.onOpen()
      }
    },
    chatMessageEdit() {
      if (!this.dialog && this.chatMessageEdit?.attachments?.length) {
        this.SET_chatFileSelect()
      }
    },
  },
  methods: {
    ...mapActions('chat', ['CREATE_chatPersonal']),
    ...mapActions('chat/messages', [
      'SEND_chatMessage',
      'UPDATE_chatMessage',
      'CANCEL_chatMessageEdit',
    ]),
    ...mapMutations('chat/file', ['SET_chatFileSelect']),
    onOpen() {
      // console.log('onOpen')
      this.$refs.modal.openModal()
    },
    onCloseModal() {
      this.$refs.modal.dialog = false
      if (this.isSeveralRecipients) {
        this.$emit('closeModal')
      }
    },
    onDefalutData() {
      this.text = ''
      this.SET_chatFileSelect({ actionType: 'clear' })
      this.sendingInProgress = false
    },
    async onSendFunction() {
      if (this.$refs.modal.validate()) {
        if (this.chatMessageEdit) {
          this.sendingInProgress = true
          let data = {
            content: this.text,
            id: this.chatMessageEdit.id,
          }
          if (this.chatFileSelect.length) {
            data.files = this.chatFileSelect
          }
          if (
            data.content !== this.chatMessageEdit.content ||
            this.chatMessageEdit.attachments.length !== this.chatFileSelect.length ||
            this.chatFileSelect.find((i) => !i.id)
          ) {
            this.UPDATE_chatMessage({
              data,
              identity: this.identity,
            })
              .then(() => {
                this.onDefalutData()
                this.onCloseModal()
                this.sendingInProgress = false
              })
              .catch(() => (this.sendingInProgress = false))
          }
        } else if (!this.isSeveralRecipients) {
          this.onCreateMessage(this.text.length ? this.text : null, this.chatFileSelect)
          this.onDefalutData()
          this.onCloseModal()
        } else {
          this.sendingInProgress = true
          let chatIds = []
          for (let recipient of this.severalRecipients) {
            if (typeof recipient === 'number') {
              const findCreatededChat = this.chats.find(
                (i) =>
                  i.type === 'PERSONAL' && !!i.participants.find((i) => i.userId === recipient),
              )
              if (findCreatededChat) {
                chatIds.push(findCreatededChat.id)
              } else {
                await this.CREATE_chatPersonal({ data: { peerId: Number(recipient) } }).then(
                  (resp) => {
                    chatIds.push(resp.id)
                  },
                )
              }
            } else {
              chatIds.push(recipient)
            }
          }
          let data = {
            content: this.text,
            chatIds,
          }
          if (this.chatFileSelect.length) {
            data.files = this.chatFileSelect
          }
          this.SEND_chatMessage({
            data,
            identity: this.identity,
          })
            .then(() => {
              this.onDefalutData()
              this.onCloseModal()
              this.sendingInProgress = false
            })
            .catch(() => (this.sendingInProgress = false))
        }
      }
    },
    onChangeFile(fileIndex) {
      // console.log('onChangeFile', fileIndex)
      this.$refs.ChatFilesUploadButton.onClickHandler(fileIndex)
    },
    onDeleteFile(fileIndex) {
      this.SET_chatFileSelect({ actionType: 'remove', changeFileIndex: fileIndex })
      if (this.chatFileSelect.length === 0 && !this.isSeveralRecipients) {
        this.onCloseModal()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.main {
  &-files {
    max-height: 500px;
  }
}
</style>
